@if (!inCarousel) {
  <a
    class="item"
    [class.locked]="item.isLocked"
    (click)="navigate($event)">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </a>
} @else {
  <div class="item rounded p-2" [class.locked]="item.isLocked">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
}


<ng-template #contentTemplate>
  <span class="item__content" [class.inactive]="!item.active">
    <div class="item-content-main">
      @if (!item.isLocked && paymentEnabled && item.payable && !item.isPaid) {
        <app-card-label
          class="dashboard-item__price"
          [show]="true"
          [label]="(item.price | currency:(item.currency | uppercase):'symbol')"
          cssClass="small">
        </app-card-label>
      }
      @if (item.mediaImage) {
        <span class="image-wrapper rounded mr-3">
          <span
            class="image rounded"
            [cropImage]="item.mediaImage | preSignedUrl | async"
            [crop]="item.mediaImage?.crop"
            imageWidth="150"
            role="img"
            [attr.aria-label]="item.mediaImage?.description || item.coverImage?.description || ''">
          </span>
        </span>
      }
      <div class="text-wrapper">
        <h4 class="ml-1 mb-0 text-break">{{item.title}}</h4>
        @if (item.parentCourseName) {
          <div class="parent-course ml-1 text-break">
            {{item.parentCourseName}}
          </div>
        }
      </div>
    </div>
  </span>
  @if (item.isLocked) {
    <div class="item__locked primary-background">
      <mat-icon svgIcon="lms-lock"></mat-icon>
    </div>
  }
  @if (item.time || progressShow || (chaptersLeft && item.amountNotFinishedSliders) || itemCountLabel || item.progress) {
    <lib-progress
      [time]="item.time"
      [progressShow]="progressShow"
      [chaptersLeft]="chaptersLeft && item.amountNotFinishedSliders"
      [itemCountLabel]="itemCountLabel"
      [progress]="item.progress">
    </lib-progress>
  }
  @if (startButton) {
    <button mat-flat-button class="button button--secondary start-button" type="button">
      <span>{{'COMMON.start_'+item.bundle | translate}}</span>
    </button>
  }
</ng-template>
